import React, { useState } from "react";
import {
  IonButton,
  IonButtons,
  IonHeader,
  IonIcon,
  IonItem, IonMenuButton,
  IonText,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { exit, moon, sunny } from "ionicons/icons";
import { useHistory } from "react-router-dom";
import { ROLE } from "../../enums/ROLE";
import userService from "../../services/UserService";
import {AuthContext} from "../../providers/authContext";

interface HeaderProps {
  title: string | undefined;
  subtitle: string | undefined;
  logo: string | undefined;
  roles: Array<ROLE>;
}

const Header: React.FC<HeaderProps> = (props) => {
  const { logOut } = React.useContext(AuthContext);
  const user = sessionStorage.getItem("user");
  const userHasRequiredRole =
    !!(user && props.roles.includes(JSON.parse(user)?.detail?.role));
  const hist = useHistory();
  const { title, subtitle, logo } = props;
  const [isAuth, setAuth] = useState<boolean>(!!user && userHasRequiredRole);

  const logout = async () => {
    const activeElement = document.activeElement as HTMLElement | null;
    activeElement?.blur();

    await userService.logout(JSON.parse(user!));
    sessionStorage.removeItem("user");
    await logOut();
    setAuth(false);
    hist.push("/yonetici/login");
  };

  return (
    <IonHeader translucent>
      <IonToolbar>
        <IonButtons slot="start">
          <IonMenuButton />
        </IonButtons>
        {isAuth && (
          <IonButtons slot="end">
            <IonButton
              onClick={async () => {
                await logout();
              }}
            >
              <IonIcon slot="start" icon={exit} />
              <IonText className="ion-hide-sm-down">Çıkış</IonText>
            </IonButton>
          </IonButtons>
        )}
        <IonTitle className="ion-text-sm-wrap">
          <IonItem className="ion-margin-top ion-margin-bottom">
            <img src={logo} alt="logo" style={{ maxWidth: "3em", height: "auto" }} />
            <IonText className="ion-padding-start ion-hide-sm-up">
              {subtitle ? subtitle : title}
            </IonText>
            <IonText
              className="ion-padding-start ion-hide-sm-down"
              style={{ fontSize: "1.5em" }}
            >
              {title} {subtitle?? '-' + subtitle}
            </IonText>
          </IonItem>
        </IonTitle>
      </IonToolbar>
    </IonHeader>
  );
};

export default Header;
